// EC Tech Savvy - Latest Electronics, Smart Gadgets & Tech Innovations
// Brand: EC Capital Investments LLC

// ============================================
// SITE IMAGES - Electronics / Tech Theme
// ============================================
export const siteImages = {
  heroMain: 'https://images.unsplash.com/photo-1601445638532-3c6f6c3aa1d6?q=80&w=1920&auto=format&fit=crop',
  heroSecondary: 'https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1920&auto=format&fit=crop',
  heroLifestyle: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?q=80&w=1920&auto=format&fit=crop',
  ctaBackground: 'https://images.unsplash.com/photo-1550009158-9ebf69173e03?q=80&w=1920&auto=format&fit=crop',
  featuredBackground: 'https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1920&auto=format&fit=crop',
  powerBackground: 'https://images.unsplash.com/photo-1526738549149-8e07eca6c147?q=80&w=1920&auto=format&fit=crop',
  shopBanner: 'https://images.unsplash.com/photo-1550009158-9ebf69173e03?q=80&w=1920&auto=format&fit=crop',
  aboutBanner: 'https://images.unsplash.com/photo-1531297484001-80022131f5a1?q=80&w=1920&auto=format&fit=crop',
  contactBanner: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=1920&auto=format&fit=crop',
  returnsBanner: 'https://images.unsplash.com/photo-1601524909162-ae8725290836?q=80&w=1920&auto=format&fit=crop',
  privacyBanner: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?q=80&w=1920&auto=format&fit=crop',
};

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '2-4 business days';
export const FREE_SHIPPING_THRESHOLD = 0; // Free shipping on all orders

export const CARD_DESCRIPTOR = '8556847001ectechsavvy';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(855) 684-7001',
  email: 'contactus@ectechsavvy.com',
  corpName: 'EC Capital Investments LLC',
  address: {
    street: '2212 N Sibley St',
    city: 'Metairie',
    state: 'LA',
    zip: '70003',
    country: 'United States'
  }
};

export const RETURN_ADDRESS = {
  street: '4711 34th St. N. Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// ELECTRONICS PRODUCTS CATALOG
// ============================================
// Specific prices applied to nearest products:
// $9.63, $12.84, $19.26, $19.37, $28.89, $58.11, $77.48,
// $142.16, $227.48, $318.72, $489.36, $612.44, $784.88, $999.00

export const products = [
  // ===== SPEAKERS =====
  {
    id: "bluetooth-computer-speaker-system",
    name: "Bluetooth Computer Speaker System",
    slug: "bluetooth-computer-speaker-system",
    sku: "EC-SPK-001",
    price: 12.84,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J0BNBP8EJV7FBNMHNWBEKY2T.jpg",
    badge: "Deal",
    categoryId: "speakers",
    categorySlug: "speakers",
    description: "Enhance your desktop experience with the Futuristic Bluetooth Computer Speaker System. Crisp stereo sound with rich bass response makes everything from music to gaming come alive.",
    keyBenefits: ["Wireless Bluetooth 5.0 connectivity", "Rich stereo sound with deep bass", "USB-powered, plug-and-play setup"],
    usage: "Connect via Bluetooth to your laptop, phone or tablet. USB cable provides power directly from your computer.",
    features: ["Bluetooth 5.0", "USB Powered", "Stereo Sound", "Compact Design"],
    inStock: true
  },
  {
    id: "smart-bluetooth-speaker-led",
    name: "Smart Bluetooth Speaker with Color-Changing LED",
    slug: "smart-bluetooth-speaker-led",
    sku: "EC-SPK-002",
    price: 19.26,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J09AS7CC0YW1C0Q7DZD6HAWH.jpg",
    badge: "Best Seller",
    categoryId: "speakers",
    categorySlug: "speakers",
    description: "Experience a fusion of sound and light with the Smart Bluetooth Speaker with Color-Changing LED. Sync the dynamic light show to your music for an immersive listening experience.",
    keyBenefits: ["360° immersive sound output", "RGB color-changing LED lighting", "Long-lasting battery up to 12 hours"],
    usage: "Pair via Bluetooth and tap the LED button to cycle through colors. Perfect for parties, gaming rooms or bedside.",
    features: ["RGB LED Lights", "12hr Battery", "Bluetooth 5.0", "Portable"],
    inStock: true
  },
  {
    id: "mini-smart-bluetooth-speaker-silicone",
    name: "Mini Smart Bluetooth Speaker with Silicone Case",
    slug: "mini-smart-bluetooth-speaker-silicone",
    sku: "EC-SPK-003",
    price: 28.89,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J09CG4VWSDPKRVX85B02BXDV.jpg",
    categoryId: "speakers",
    categorySlug: "speakers",
    description: "The Mini Smart Bluetooth Speaker with Silicone Case is a compact, stylish audio companion. Take big sound on the go with shock-absorbing protection.",
    keyBenefits: ["Protective silicone case", "Big sound from a small footprint", "Pocket-sized portability"],
    usage: "Take it everywhere — beach, hiking, commute. Pair with your phone for instant audio.",
    features: ["Silicone Bumper", "Mini Form Factor", "Bluetooth 5.0", "Built-in Mic"],
    inStock: true
  },
  {
    id: "chic-heart-mini-bluetooth-speaker",
    name: "Chic Heart Mini Bluetooth Speaker",
    slug: "chic-heart-mini-bluetooth-speaker",
    sku: "EC-SPK-004",
    price: 80.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HZMKYSYRMBY8HZM6ZPJ2KCGJ.jpg",
    categoryId: "speakers",
    categorySlug: "speakers",
    description: "Add a touch of elegance and superb sound quality to your audio experience with our Chic Heart Mini Bluetooth Speaker. Heart-shaped design with premium acoustics.",
    keyBenefits: ["Unique heart-shaped design", "Premium acoustic drivers", "Pairs perfectly as desk decor"],
    usage: "Place on your desk or nightstand. Pair via Bluetooth for instant listening.",
    features: ["Designer Look", "Premium Audio", "Bluetooth 5.0", "Rechargeable"],
    inStock: true
  },
  {
    id: "hd-soundbar-with-subwoofer",
    name: "HD Soundbar with Subwoofer",
    slug: "hd-soundbar-with-subwoofer",
    sku: "EC-SPK-005",
    price: 84.25,
    image: "https://novagen.s3.us-east-2.amazonaws.com/2AcnDnCC0TEDlNuC0lIzKzZmiQwN58TqS5c1EG4p.png",
    badge: "Premium",
    categoryId: "speakers",
    categorySlug: "speakers",
    description: "Compact 2.1-channel HD soundbar paired with a wireless subwoofer, 120 watts total power, Bluetooth, HDMI ARC and optical input.",
    keyBenefits: ["2.1-channel HD audio", "Wireless subwoofer included", "Multiple connectivity options"],
    usage: "Mount under your TV or place on the media console. Connect via HDMI ARC for one-cable setup.",
    features: ["120W Power", "Wireless Sub", "HDMI ARC", "Bluetooth"],
    inStock: true
  },
  {
    id: "portable-bluetooth-speaker",
    name: "Portable Bluetooth Speaker",
    slug: "portable-bluetooth-speaker",
    sku: "EC-SPK-006",
    price: 99.95,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HZMJWMG01Y7KWEEAZ8VBAEPC.jpg",
    categoryId: "speakers",
    categorySlug: "speakers",
    description: "Unleash powerful and dynamic sound wherever you go with our Robust Portable Bluetooth Speaker. IP67 water-resistant and built for adventure.",
    keyBenefits: ["IP67 water-resistant build", "20-hour battery life", "Powerful 40W stereo output"],
    usage: "Bring to the pool, beach or campsite. Stereo-pair two speakers for full surround.",
    features: ["IP67 Rated", "20hr Battery", "40W Output", "Stereo Pair"],
    inStock: true
  },

  // ===== HEADPHONES & EARBUDS =====
  {
    id: "touch-control-true-wireless-earbuds",
    name: "Touch-Control True Wireless Earbuds",
    slug: "touch-control-true-wireless-earbuds",
    sku: "EC-AUD-001",
    price: 40.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HZMJD2REDNBBJFD28P8BP3YE.jpg",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Step into a world of crystal-clear sound with our Compact Touch-Control True Wireless Earbuds. Intuitive touch controls and seamless pairing.",
    keyBenefits: ["Intuitive touch controls", "Compact charging case", "Clear voice calls"],
    usage: "Tap to play/pause or skip tracks. Charge via USB-C in the included case.",
    features: ["Touch Controls", "USB-C Case", "Bluetooth 5.2", "IPX4 Sweatproof"],
    inStock: true
  },
  {
    id: "open-ear-bone-conduction-headset",
    name: "Open-Ear Bone Conduction Headset",
    slug: "open-ear-bone-conduction-headset",
    sku: "EC-AUD-002",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/tiR8fl58thUuhIwFBnTXKqOy9h8zafLGPQBWBb4d.png",
    badge: "Sport",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Open-ear bone conduction headset for runners and cyclists. Bluetooth 5.2, IP67 sweat resistance, 8-hour battery life and dual-microphone noise reduction.",
    keyBenefits: ["Open-ear safe design", "IP67 sweat & water resistant", "8-hour playback battery"],
    usage: "Ideal for outdoor running, cycling and workouts where situational awareness matters.",
    features: ["Bone Conduction", "IP67 Rated", "Bluetooth 5.2", "8hr Battery"],
    inStock: true
  },
  {
    id: "active-noise-cancelling-earbuds-pro",
    name: "Active Noise-Cancelling Earbuds Pro",
    slug: "active-noise-cancelling-earbuds-pro",
    sku: "EC-AUD-003",
    price: 87.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/sYSRnrMgToy1mcA5rewreSId2TR07vDUclS9LATv.png",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Premium true-wireless earbuds with adaptive active noise cancellation, 32-hour total battery life with the charging case and immersive spatial audio.",
    keyBenefits: ["Adaptive active noise cancellation", "32-hour total battery", "Spatial audio support"],
    usage: "Wear for travel, work or calls. ANC adapts automatically to your environment.",
    features: ["Active ANC", "32hr Battery", "Spatial Audio", "Wireless Charging"],
    inStock: true
  },
  {
    id: "gaming-headset-rgb",
    name: "Gaming Headset with RGB Lighting",
    slug: "gaming-headset-rgb",
    sku: "EC-AUD-004",
    price: 102.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/IEpGs3LKs2R34Rp8E00x5byOhRH74cpvbz8FUOGM.png",
    badge: "Gaming",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Over-ear gaming headset with 50mm neodymium drivers, customizable RGB lighting on each earcup, detachable boom microphone and memory foam earpads.",
    keyBenefits: ["50mm drivers for immersive audio", "Customizable RGB on earcups", "Detachable boom mic"],
    usage: "Plug into PC, PlayStation or Xbox. Customize lighting through companion software.",
    features: ["50mm Drivers", "RGB Lighting", "Boom Mic", "Memory Foam"],
    inStock: true
  },
  {
    id: "modern-wireless-headphones",
    name: "Modern Wireless Headphones",
    slug: "modern-wireless-headphones",
    sku: "EC-AUD-005",
    price: 142.16,
    image: "https://novagen.s3.us-east-2.amazonaws.com/vI2q4IFJf81VmvHKWJuEjGRHJbyitaFGg0icOElG.jpg",
    badge: "Popular",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Experience exceptional audio quality with our Sleek Modern Wireless Headphones. Plush cushioning and balanced sound profile for hours of comfort.",
    keyBenefits: ["Hi-fi balanced audio profile", "Plush over-ear cushioning", "30-hour wireless battery"],
    usage: "Wear all day for music, calls and content. Foldable design for easy travel.",
    features: ["Hi-Fi Audio", "30hr Battery", "Foldable", "Bluetooth 5.2"],
    inStock: true
  },
  {
    id: "wireless-noise-cancelling-headphones",
    name: "Wireless Noise-Cancelling Headphones",
    slug: "wireless-noise-cancelling-headphones",
    sku: "EC-AUD-006",
    price: 227.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/AcxyRrf2T4tOa7BmHEdstLp2TLtjgC0frVP7KRSZ.jpg",
    badge: "Premium",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Immerse yourself in the world of high-definition audio with our Luxe Wireless Noise-Cancelling Headphones. Block distractions with industry-leading ANC.",
    keyBenefits: ["Industry-leading active noise cancellation", "Hi-resolution wireless audio", "Premium leather earcups"],
    usage: "Block out planes, trains and offices. Touch controls handle volume, calls and tracks.",
    features: ["Hybrid ANC", "Hi-Res Audio", "Touch Controls", "40hr Battery"],
    inStock: true
  },
  {
    id: "professional-studio-monitor-headphones",
    name: "Professional Studio Monitor Headphones",
    slug: "professional-studio-monitor-headphones",
    sku: "EC-AUD-007",
    price: 318.72,
    image: "https://novagen.s3.us-east-2.amazonaws.com/x2xn1eCJmztLBikTIH8vfd0ZNNHauidabl7sl0kE.png",
    badge: "Pro Audio",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Reference-grade closed-back studio monitor headphones with 45mm graphene-coated drivers, flat frequency response and detachable cable. Built for engineers and producers.",
    keyBenefits: ["Reference-grade flat response", "45mm graphene drivers", "Detachable cable system"],
    usage: "Mix, master and produce with confidence. Closed-back design isolates studio environments.",
    features: ["Studio Reference", "45mm Drivers", "Detachable Cable", "Closed-Back"],
    inStock: true
  },
  {
    id: "audiophile-reference-headphones-pro",
    name: "Audiophile Reference Headphones Pro",
    slug: "audiophile-reference-headphones-pro",
    sku: "EC-AUD-008",
    price: 612.44,
    image: "https://images.unsplash.com/photo-1583394838336-acd977736f90?q=80&w=1200&auto=format&fit=crop",
    badge: "Flagship",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Flagship audiophile-grade open-back headphones with planar magnetic drivers, hand-built wooden earcups and balanced cable system for the ultimate listening experience.",
    keyBenefits: ["Planar magnetic driver technology", "Hand-finished wooden earcups", "Balanced cable system included"],
    usage: "Pair with a dedicated headphone amp/DAC for serious critical listening sessions.",
    features: ["Planar Magnetic", "Open-Back", "Wooden Earcups", "Balanced Cable"],
    inStock: true
  },

  // ===== GAMING GEAR =====
  {
    id: "wireless-bluetooth-gaming-mouse",
    name: "Wireless Bluetooth Gaming Mouse",
    slug: "wireless-bluetooth-gaming-mouse",
    sku: "EC-GMG-001",
    price: 50.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J0BT9HK63QHKR4TD8E3TDYMT.jpg",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "Unleash peak gaming performance with the High-Performance Wireless Bluetooth Gaming Mouse. 16,000 DPI optical sensor and programmable buttons.",
    keyBenefits: ["16,000 DPI optical sensor", "Programmable side buttons", "Ergonomic right-hand grip"],
    usage: "Gamers and power users. Pair via Bluetooth or use the 2.4GHz dongle for low-latency play.",
    features: ["16K DPI", "Programmable", "Wireless", "Ergonomic"],
    inStock: true
  },
  {
    id: "jazz-mechanical-keyboard",
    name: "Jazz Mechanical Keyboard with Customizable Keys",
    slug: "jazz-mechanical-keyboard",
    sku: "EC-GMG-002",
    price: 58.11,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J0BP39GWWY6MQD879RXYW3W4.jpg",
    badge: "Hot-Swap",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "Type with satisfying tactile feedback on this hot-swappable mechanical keyboard. PBT keycaps, RGB backlighting and onboard memory for your custom layouts.",
    keyBenefits: ["Hot-swappable mechanical switches", "Durable PBT keycaps", "Per-key RGB backlight"],
    usage: "Plug-and-play with USB-C. Swap switches without soldering and tune your typing feel.",
    features: ["Hot-Swap", "PBT Keycaps", "Per-Key RGB", "USB-C"],
    inStock: true
  },
  {
    id: "azure-ice-mechanical-keyboard",
    name: "Azure Ice Mechanical Keyboard",
    slug: "azure-ice-mechanical-keyboard",
    sku: "EC-GMG-003",
    price: 60.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J0BQ9NBNCT844ATSE386HFX3.jpg",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "Make a statement at your desk with this frost-blue mechanical keyboard. Translucent keycaps with stunning icy RGB diffusion.",
    keyBenefits: ["Translucent ice-blue keycaps", "Stunning RGB light diffusion", "Tactile mechanical switches"],
    usage: "Plug into your gaming rig and customize lighting effects. Built for marathon sessions.",
    features: ["Ice-Blue Caps", "RGB Diffusion", "Mechanical", "Anti-Ghosting"],
    inStock: true
  },
  {
    id: "wireless-gaming-mouse",
    name: "Wireless Gaming Mouse",
    slug: "wireless-gaming-mouse",
    sku: "EC-GMG-004",
    price: 90.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/LAhFM1viFVQ71iaudgUW6qXIQXWxNleKFaeLA5Cr.jpg",
    badge: "Esports",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "Gain a competitive edge with this lightweight wireless gaming mouse engineered for esports. Sub-1ms response and ultra-light shell.",
    keyBenefits: ["Sub-1ms wireless latency", "Ultra-light 63g shell", "Pro-grade 26K DPI sensor"],
    usage: "Competitive FPS and MMO players. Charges via USB-C with 80+ hour battery life.",
    features: ["63g Lightweight", "26K DPI", "Sub-1ms", "80hr Battery"],
    inStock: true
  },
  {
    id: "deep-black-esports-mouse",
    name: "Deep Black Wireless Bluetooth Gaming Esports Mouse",
    slug: "deep-black-esports-mouse",
    sku: "EC-GMG-005",
    price: 100.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J0BRFZ49W5Q63YJ5D01K4QP1.jpg",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "The Deep Black Wireless Bluetooth Gaming Esports Mouse is engineered for precision and speed. Custom-tuned switches rated for 70M clicks.",
    keyBenefits: ["70M-click rated switches", "Adjustable lift-off distance", "Onboard memory profiles"],
    usage: "Plug the 2.4GHz dongle in or use Bluetooth on the go. Save up to 5 profiles onboard.",
    features: ["70M Clicks", "Onboard Memory", "Adjustable LOD", "RGB"],
    inStock: true
  },
  {
    id: "wireless-gaming-keyboard-macro",
    name: "Wireless Gaming Keyboard with Macro Keys",
    slug: "wireless-gaming-keyboard-macro",
    sku: "EC-GMG-006",
    price: 216.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/2JdgctIeX6qhjbyAkjBJBNPlhQIb9HOyqV1e5qqE.png",
    badge: "Pro Gaming",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "Full-size wireless gaming keyboard with hot-swappable mechanical switches, dedicated macro keys, programmable rotary control and triple-mode connectivity.",
    keyBenefits: ["Triple-mode wireless connectivity", "Dedicated macro & media keys", "Hot-swappable switches"],
    usage: "Pair via Bluetooth, 2.4GHz or wired USB-C. Set complex macros directly on the keyboard.",
    features: ["Triple-Mode", "Macro Keys", "Hot-Swap", "Rotary Knob"],
    inStock: true
  },

  // ===== COMPUTER ACCESSORIES =====
  {
    id: "adjustable-ergonomic-laptop-stand",
    name: "Adjustable Ergonomic Laptop Stand",
    slug: "adjustable-ergonomic-laptop-stand",
    sku: "EC-CMP-001",
    price: 19.37,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J0BXCJECE53NH51VA7GCKEYH.jpg",
    badge: "Ergo",
    categoryId: "computer-accessories",
    categorySlug: "computer-accessories",
    description: "Enhance your work setup with this Adjustable Ergonomic Laptop Stand, designed to lift your screen to eye level. Aluminum body, foldable and travel-friendly.",
    keyBenefits: ["Lifts laptop to ergonomic eye-level", "Foldable aluminum design", "Ventilated to keep laptops cool"],
    usage: "Place your laptop on the stand, adjust the angle and connect external keyboard/mouse for proper posture.",
    features: ["Adjustable Height", "Aluminum", "Foldable", "Ventilated"],
    inStock: true
  },
  {
    id: "4k-usb-c-webcam",
    name: "4K USB-C Webcam",
    slug: "4k-usb-c-webcam",
    sku: "EC-CMP-002",
    price: 112.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/d2hRtvK6tNwuiU8ZOaYnwET7AUKI6K0tERt4cKpG.png",
    badge: "4K",
    categoryId: "computer-accessories",
    categorySlug: "computer-accessories",
    description: "Premium 4K ultra-HD USB-C webcam with 1/2.8-inch Sony sensor, dual-microphone beamforming and AI auto-framing for crystal-clear video calls.",
    keyBenefits: ["True 4K ultra-HD video", "AI auto-framing follows you", "Dual-microphone beamforming"],
    usage: "Plug into any USB-C laptop or desktop. Perfect for streaming, conferencing and content creation.",
    features: ["4K UHD", "AI Auto-Frame", "Beamforming Mic", "USB-C"],
    inStock: true
  },
  {
    id: "portable-ssd-external-drive",
    name: "Portable SSD External Drive",
    slug: "portable-ssd-external-drive",
    sku: "EC-CMP-003",
    price: 156.50,
    image: "https://novagen.s3.us-east-2.amazonaws.com/56t5UAJgakNvmsqc5GEfazTv2b5jEMTZmlsHF9ly.png",
    badge: "1 TB",
    categoryId: "computer-accessories",
    categorySlug: "computer-accessories",
    description: "Ultra-compact 1 TB portable external SSD with USB 3.2 Gen 2, read speeds up to 1,050 MB/s and rugged shock-resistant build.",
    keyBenefits: ["1 TB high-capacity storage", "Up to 1,050 MB/s read speeds", "Shock-resistant rugged shell"],
    usage: "Back up laptops, store project files or transport large media libraries between machines.",
    features: ["1 TB Capacity", "1050 MB/s", "USB 3.2 Gen 2", "Shockproof"],
    inStock: true
  },
  {
    id: "portable-power-bank",
    name: "Portable Power Bank",
    slug: "portable-power-bank",
    sku: "EC-CMP-004",
    price: 9.63,
    image: "https://novagen.s3.us-east-2.amazonaws.com/V9k6qTVt5hh82slLBMPKlbg1odYukKPcz4XwE9gf.webp",
    badge: "Deal",
    categoryId: "computer-accessories",
    categorySlug: "computer-accessories",
    description: "A high-capacity portable power bank with a 10,000mAh battery, perfect for charging phones, tablets and earbuds on the go. Dual USB output and LED capacity indicator.",
    keyBenefits: ["10,000mAh high capacity", "Dual USB outputs", "LED capacity indicator"],
    usage: "Charge before leaving home. Plug in any USB device for fast top-ups anywhere.",
    features: ["10000 mAh", "Dual USB", "LED Indicator", "Slim Design"],
    inStock: true
  },

  // ===== TABLETS & DRAWING =====
  {
    id: "digital-drawing-display-stylus",
    name: "Digital Drawing Display with Stylus Pen",
    slug: "digital-drawing-display-stylus",
    sku: "EC-TAB-001",
    price: 70.00,
    image: "https://ae01.alicdn.com/kf/H80b2cf08762a4281aa914ac0f3c0e4e40.jpg",
    categoryId: "tablets",
    categorySlug: "tablets",
    description: "Sketch, illustrate and annotate directly on screen with this pen display tablet. 8192 levels of pressure sensitivity and full HD resolution.",
    keyBenefits: ["8192 levels of pressure sensitivity", "Full HD display", "Battery-free stylus included"],
    usage: "Connect to PC or Mac for digital illustration, photo editing and digital note-taking.",
    features: ["8192 Pressure", "Full HD", "Battery-Free Pen", "Tilt Recognition"],
    inStock: true
  },
  {
    id: "smart-tablet-with-keyboard",
    name: "Smart Tablet with Keyboard",
    slug: "smart-tablet-with-keyboard",
    sku: "EC-TAB-002",
    price: 85.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HZFKYRP3XW8699HHNZ1Z71S8.jpg",
    badge: "2-in-1",
    categoryId: "tablets",
    categorySlug: "tablets",
    description: "Blend tablet portability with laptop productivity using this 2-in-1 device and its included detachable keyboard. Perfect for travel and remote work.",
    keyBenefits: ["2-in-1 detachable keyboard", "Crisp 10.1-inch display", "All-day battery life"],
    usage: "Detach the keyboard for tablet mode, snap it back on for laptop-style typing.",
    features: ["Detachable Keyboard", "10.1\" Display", "All-Day Battery", "Touchscreen"],
    inStock: true
  },
  {
    id: "advanced-ebook-reader",
    name: "Advanced e-Book Reader with Digital Pen",
    slug: "advanced-ebook-reader",
    sku: "EC-TAB-003",
    price: 248.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J0BVSH4BG563GHYWR2GNH39A.jpg",
    categoryId: "tablets",
    categorySlug: "tablets",
    description: "The Advanced e-Book Reader with Digital Pen is a cutting-edge device designed for readers and note-takers. Paper-like E-Ink display with stylus support.",
    keyBenefits: ["Paper-like E-Ink display", "Digital pen for handwritten notes", "Weeks of battery on a single charge"],
    usage: "Read for hours without eye strain, annotate PDFs and journal directly on the device.",
    features: ["E-Ink Display", "Digital Pen", "Weeks of Battery", "Glare-Free"],
    inStock: true
  },
  {
    id: "classic-black-graphic-drawing-tablet",
    name: "Classic Black Graphic Drawing Tablet",
    slug: "classic-black-graphic-drawing-tablet",
    sku: "EC-TAB-004",
    price: 247.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/CsbEim2iq7bVoNFsjVhBzbUuSGOgKDgHgPPRixEb.png",
    categoryId: "tablets",
    categorySlug: "tablets",
    description: "The Classic Black Graphic Drawing Tablet is a versatile tool designed for both aspiring and professional digital artists. Wide active area and shortcut keys.",
    keyBenefits: ["Large 10x6-inch active area", "Programmable shortcut keys", "Compatible with major creative software"],
    usage: "Pair with Photoshop, Illustrator, Clip Studio or any major digital art software.",
    features: ["10x6 Active Area", "Shortcut Keys", "Pressure Sensitive", "USB-C"],
    inStock: true
  },
  {
    id: "graphic-tablet-monitor-stylus",
    name: "Graphic Tablet Monitor with Shortcut Keys and Digital Stylus",
    slug: "graphic-tablet-monitor-stylus",
    sku: "EC-TAB-005",
    price: 249.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/zvQUJygDjugg5U1VK6sVHqpeE2Yo5Ou7EqV3eoiM.png",
    badge: "Artist",
    categoryId: "tablets",
    categorySlug: "tablets",
    description: "The ProArtist Graphic Tablet Monitor caters to aspiring and professional digital artists. Vivid display, programmable shortcut keys and precision stylus.",
    keyBenefits: ["Vivid integrated HD display", "Programmable shortcut keys", "Precision battery-free stylus"],
    usage: "Connect to PC or Mac as a second display. Draw directly on the screen for natural workflow.",
    features: ["HD Display", "Shortcut Keys", "Battery-Free Pen", "Tilt Support"],
    inStock: true
  },
  {
    id: "premium-digital-graphics-workstation-tablet",
    name: "Premium Digital Graphics Workstation Tablet",
    slug: "premium-digital-graphics-workstation-tablet",
    sku: "EC-TAB-006",
    price: 489.36,
    image: "https://images.unsplash.com/photo-1561154464-82e9adf32764?q=80&w=1200&auto=format&fit=crop",
    badge: "Pro Studio",
    categoryId: "tablets",
    categorySlug: "tablets",
    description: "Top-of-the-line digital graphics workstation tablet with a 4K color-accurate display, 16,384 levels of pen pressure and full multi-touch support. Built for professional creators.",
    keyBenefits: ["4K color-accurate display", "16,384 pen pressure levels", "Multi-touch gesture support"],
    usage: "Professional illustrators, designers and animators. Calibrate for studio-grade color accuracy.",
    features: ["4K Display", "16K Pressure", "Multi-Touch", "Color Calibrated"],
    inStock: true
  },

  // ===== MONITORS & DISPLAYS =====
  {
    id: "mini-hd-projector",
    name: "Mini HD Projector",
    slug: "mini-hd-projector",
    sku: "EC-DSP-001",
    price: 92.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/hOYAvOWzOb0pLcgP3NPEA9Ds0MOlJGPLFXeDjXH8.png",
    categoryId: "displays",
    categorySlug: "displays",
    description: "Portable mini HD projector with native 1080p support, 200 ANSI lumens, HDMI/USB-C inputs and built-in speaker. Movie nights, anywhere.",
    keyBenefits: ["Native 1080p HD projection", "200 ANSI lumens brightness", "Built-in speaker & HDMI"],
    usage: "Project on a wall or screen up to 120 inches. Plug in any HDMI source for instant cinema.",
    features: ["1080p HD", "200 ANSI", "Built-in Speaker", "HDMI/USB-C"],
    inStock: true
  },
  {
    id: "ultra-wide-curved-monitor",
    name: "Ultra-Wide Curved Computer Monitor",
    slug: "ultra-wide-curved-monitor",
    sku: "EC-DSP-002",
    price: 207.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/YUyi0mcklSRlZjQRPLnURiaAbjsyoZvbZXsD6ceB.png",
    badge: "34\"",
    categoryId: "displays",
    categorySlug: "displays",
    description: "Immersive 34-inch ultra-wide curved monitor with WQHD 3440x1440 resolution, 165Hz refresh rate and HDR support. Built for productivity and gaming.",
    keyBenefits: ["34-inch ultra-wide curved screen", "165Hz refresh rate", "HDR-ready WQHD resolution"],
    usage: "Spread out spreadsheets and timelines for productivity, or dive into immersive games.",
    features: ["34\" Ultra-Wide", "165Hz", "WQHD", "HDR"],
    inStock: true
  },
  {
    id: "flagship-8k-ultrawide-monitor",
    name: "Flagship 8K Ultra-Wide Gaming Monitor",
    slug: "flagship-8k-ultrawide-monitor",
    sku: "EC-DSP-003",
    price: 784.88,
    image: "https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?q=80&w=1200&auto=format&fit=crop",
    badge: "8K",
    categoryId: "displays",
    categorySlug: "displays",
    description: "Flagship 8K ultra-wide gaming monitor with 240Hz refresh rate, mini-LED backlight, sub-1ms response time and full HDR1000 certification. The ultimate gaming display.",
    keyBenefits: ["8K resolution clarity", "240Hz mini-LED panel", "HDR1000 certified"],
    usage: "Pair with a high-end GPU for the ultimate gaming and creator workstation experience.",
    features: ["8K Resolution", "240Hz", "Mini-LED", "HDR1000"],
    inStock: true
  },
  {
    id: "elite-studio-production-display",
    name: "Elite Studio Production Reference Display",
    slug: "elite-studio-production-display",
    sku: "EC-DSP-004",
    price: 999.00,
    image: "https://images.unsplash.com/photo-1593640408182-31c70c8268f5?q=80&w=1200&auto=format&fit=crop",
    badge: "Flagship",
    categoryId: "displays",
    categorySlug: "displays",
    description: "Reference-grade studio production display with 99% Adobe RGB coverage, factory-calibrated color accuracy, 5K resolution and Thunderbolt connectivity. Built for color-critical work.",
    keyBenefits: ["99% Adobe RGB coverage", "Factory color-calibrated", "Thunderbolt single-cable workflow"],
    usage: "Professional photo and video editors, motion designers and color graders.",
    features: ["5K Display", "99% Adobe RGB", "Thunderbolt", "Calibrated"],
    inStock: true
  },

  // ===== SMART HOME & ENTERTAINMENT =====
  {
    id: "elite-vr-headset",
    name: "Elite All-In-One Virtual Reality Headset",
    slug: "elite-vr-headset",
    sku: "EC-SMH-001",
    price: 75.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/eTAcRwGzxtvjNauVTAsJNe59HeK0FUzccLifq6n9.png",
    badge: "VR",
    categoryId: "smart-home",
    categorySlug: "smart-home",
    description: "Dive into immersive virtual worlds without a PC or console tethering you down. The all-in-one design includes built-in tracking and motion controllers.",
    keyBenefits: ["Standalone — no PC required", "Built-in inside-out tracking", "Includes motion controllers"],
    usage: "Wear the headset, pick up the controllers and explore games, fitness and media in VR.",
    features: ["Standalone", "Inside-Out Tracking", "Motion Controllers", "Built-in Audio"],
    inStock: true
  },
  {
    id: "mini-karaoke-microphone-speaker-set",
    name: "Mini Karaoke Microphone and Speaker Set",
    slug: "mini-karaoke-microphone-speaker-set",
    sku: "EC-SMH-002",
    price: 65.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HZMM41GZAY06F31H03E6299M.jpg",
    categoryId: "smart-home",
    categorySlug: "smart-home",
    description: "Elevate your singing sessions with our Dynamic Mini Karaoke Microphone and Speaker Set. Voice effects, echo and Bluetooth pairing built-in.",
    keyBenefits: ["All-in-one mic and speaker", "Voice effects and echo built-in", "Pairs to any phone or tablet"],
    usage: "Sing along with backing tracks from your phone. Great for parties and family fun.",
    features: ["Built-in Speaker", "Voice Effects", "Bluetooth", "Rechargeable"],
    inStock: true
  },
  {
    id: "karaoke-streaming-sound-system",
    name: "All-in-One Karaoke and Streaming Sound System",
    slug: "karaoke-streaming-sound-system",
    sku: "EC-SMH-003",
    price: 55.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HZMMFHPSTJDF59YWXCSPMZ95.jpg",
    categoryId: "smart-home",
    categorySlug: "smart-home",
    description: "Host impromptu sing-alongs or stream music with room-filling sound from this portable karaoke speaker. Includes wireless microphone.",
    keyBenefits: ["Room-filling 360° sound", "Wireless microphone included", "Streaming-ready Bluetooth"],
    usage: "Connect to your phone for music streaming or karaoke tracks. Sing with the wireless mic.",
    features: ["360° Sound", "Wireless Mic", "Bluetooth", "Portable Handle"],
    inStock: true
  },
  {
    id: "smart-home-hub-controller",
    name: "Smart Home Hub Controller",
    slug: "smart-home-hub-controller",
    sku: "EC-SMH-004",
    price: 177.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/0vJhH8RZWObWFuKGy2QJsD3uPO1OUIIe3u51hjMf.png",
    badge: "Smart",
    categoryId: "smart-home",
    categorySlug: "smart-home",
    description: "Central smart-home hub supporting Matter, Zigbee, Z-Wave, Thread and Wi-Fi, with voice assistant compatibility for an interconnected home.",
    keyBenefits: ["Universal Matter/Zigbee/Z-Wave support", "Works with major voice assistants", "Local control for fast response"],
    usage: "Connect your smart lights, locks, sensors and thermostats to one hub for unified control.",
    features: ["Matter Ready", "Zigbee/Z-Wave", "Thread", "Voice Compatible"],
    inStock: true
  },

  // ============================================
  // EXPANDED PRICE-POINT CATALOG (MID coverage)
  // ============================================

  // ----- Speakers -----
  {
    id: "studiobox-2hd-bluetooth-speaker",
    name: "Studiobox 2HD Mahogany Bluetooth Speaker",
    slug: "studiobox-2hd-bluetooth-speaker",
    sku: "EC-SPK-007",
    price: 99.00,
    image: "/products/p13-sonicgear-studiobox-2hd.png",
    categoryId: "speakers",
    categorySlug: "speakers",
    description: "Premium 2.0-channel Bluetooth bookshelf speaker system with 70W RMS power, wood-finish cabinets and multiple input options for desktop or living-room use.",
    keyBenefits: ["70W RMS warm bookshelf sound", "Bluetooth, RCA & Optical inputs", "Furniture-grade wood finish"],
    usage: "Pair via Bluetooth or wire to a TV, turntable or PC for a full stereo soundstage at home.",
    features: ["70W RMS", "Bluetooth 5.0", "Optical In", "2.0 Channel"],
    inStock: true
  },
  {
    id: "tuner-3-bluetooth-radio-speaker",
    name: "Tuner 3 Portable Bluetooth Radio Speaker",
    slug: "tuner-3-bluetooth-radio-speaker",
    sku: "EC-SPK-008",
    price: 140.00,
    image: "/products/p18-jbl-tuner-3.jpg",
    badge: "DAB+/FM",
    categoryId: "speakers",
    categorySlug: "speakers",
    description: "Portable IP68 Bluetooth radio speaker with built-in DAB / DAB+ / FM tuner, crisp LCD display and up to 15 hours of playback on a single charge.",
    keyBenefits: ["IP68 dust & waterproof build", "DAB+/FM radio with LCD display", "Up to 15-hour battery life"],
    usage: "Take it to the kitchen, garage or backyard — perfect for radio, podcasts and Bluetooth streaming.",
    features: ["IP68 Rated", "DAB+/FM", "Bluetooth", "15hr Battery"],
    inStock: true
  },
  {
    id: "bar-20-all-in-one-soundbar",
    name: "Bar 2.0 All-in-One Soundbar",
    slug: "bar-20-all-in-one-soundbar",
    sku: "EC-SPK-009",
    price: 195.00,
    image: "/products/p21-jbl-bar-20.png",
    badge: "Dolby",
    categoryId: "speakers",
    categorySlug: "speakers",
    description: "Sleek all-in-one 2.0 soundbar with deep bass, virtual surround sound, Dolby Digital decoding and 80W of room-filling power.",
    keyBenefits: ["80W max output power", "Virtual surround sound", "Dolby Digital decoding"],
    usage: "Mount under your TV for an instant upgrade over built-in speakers — one cable, big sound.",
    features: ["80W Power", "Virtual Surround", "Dolby Digital", "Bluetooth"],
    inStock: true
  },

  // ----- Headphones & Earbuds -----
  {
    id: "tune-110e-wired-earphones",
    name: "Tune 110E Wired Earphones",
    slug: "tune-110e-wired-earphones",
    sku: "EC-AUD-009",
    price: 13.99,
    image: "/products/p1-jbl-tune-110e.jpg",
    badge: "Deal",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Classic wired in-ear earphones tuned for punchy bass with a one-button remote and built-in mic for hands-free calls.",
    keyBenefits: ["Pure Bass tuned drivers", "One-button remote + mic", "Tangle-free flat cable"],
    usage: "Plug into any 3.5mm jack for everyday music, podcasts and clear voice calls.",
    features: ["Pure Bass", "1-Button Remote", "Flat Cable", "3.5mm"],
    inStock: true
  },
  {
    id: "quantum-100p-console-gaming-headset",
    name: "Quantum 100P Console Gaming Headset",
    slug: "quantum-100p-console-gaming-headset",
    sku: "EC-AUD-010",
    price: 43.00,
    image: "/products/p4-jbl-quantum-100p.jpg",
    badge: "Gaming",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Console-ready gaming headset with QuantumSOUND Signature audio, PlayStation 5 3D Audio support and cross-platform compatibility with PC and Xbox.",
    keyBenefits: ["PlayStation 5 3D Audio ready", "Cross-platform compatibility", "Detachable boom microphone"],
    usage: "Plug the 3.5mm cable into your controller, PC or console for instant immersive gaming audio.",
    features: ["3D Audio", "Detachable Mic", "Cross-Platform", "Memory Foam"],
    inStock: true
  },
  {
    id: "quantum-100m2-purple-gaming-headset",
    name: "Quantum 100M2 Purple Gaming Headset",
    slug: "quantum-100m2-purple-gaming-headset",
    sku: "EC-AUD-011",
    price: 44.00,
    image: "/products/p5-jbl-quantum-100m2.png",
    badge: "Gaming",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Wired over-ear gaming headset with QuantumSOUND, breathable cloth earpads, detachable microphone and Windows Sonic Spatial Sound support.",
    keyBenefits: ["Windows Sonic Spatial Sound", "Breathable cloth earpads", "Detachable boom mic"],
    usage: "Connect to PC or laptop and tune your audio profile with QuantumENGINE software.",
    features: ["Spatial Sound", "Cloth Earpads", "Detachable Mic", "Tuned EQ"],
    inStock: true
  },
  {
    id: "orion-7-wireless-gaming-headphones",
    name: "Orion 7 Wireless Gaming Headphones",
    slug: "orion-7-wireless-gaming-headphones",
    sku: "EC-AUD-012",
    price: 49.00,
    image: "/products/p7-armaggeddon-orion-7.png",
    badge: "Wireless",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Triple-mode wireless gaming headphones with 50mm Neodymium drivers, up to 40 hours of battery life and a lightweight 258g design.",
    keyBenefits: ["50mm Neodymium drivers", "Up to 40-hour battery", "2.4GHz / Bluetooth 5.4 / Aux"],
    usage: "Switch between low-latency 2.4GHz for gaming and Bluetooth for phone calls without missing a beat.",
    features: ["Triple-Mode", "40hr Battery", "50mm Drivers", "Bluetooth 5.4"],
    inStock: true
  },
  {
    id: "tune-520bt-wireless-headphones",
    name: "Tune 520BT Wireless Headphones",
    slug: "tune-520bt-wireless-headphones",
    sku: "EC-AUD-013",
    price: 57.00,
    image: "/products/p9-jbl-tune-520bt.png",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Lightweight on-ear wireless headphones with Pure Bass sound, up to 57 hours of playback, app personalization and multi-point connection.",
    keyBenefits: ["Up to 57-hour playback", "App-based sound personalization", "Multi-point Bluetooth 5.3"],
    usage: "Pair with two devices at once — switch seamlessly between laptop calls and phone music.",
    features: ["57hr Battery", "Bluetooth 5.3", "Multi-Point", "App Tuning"],
    inStock: true
  },
  {
    id: "tune-730bt-wireless-headphones",
    name: "Tune 730BT Wireless Headphones",
    slug: "tune-730bt-wireless-headphones",
    sku: "EC-AUD-014",
    price: 78.00,
    image: "/products/p11-jbl-tune-730bt.jpg",
    badge: "Bluetooth 6.0",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Over-ear wireless headphones with dual beamforming microphones, up to 76 hours of battery life and the latest Bluetooth 6.0 multi-point connection.",
    keyBenefits: ["Up to 76-hour battery life", "Dual beamforming microphones", "Latest Bluetooth 6.0"],
    usage: "All-day music, video calls and travel — the long battery means you rarely need a charger.",
    features: ["76hr Battery", "Bluetooth 6.0", "Beamforming Mic", "Multi-Point"],
    inStock: true
  },
  {
    id: "tune-680nc-anc-headphones",
    name: "Tune 680NC Adaptive ANC Headphones",
    slug: "tune-680nc-anc-headphones",
    sku: "EC-AUD-015",
    price: 93.00,
    image: "/products/p12-jbl-tune-680nc.jpg",
    badge: "Adaptive ANC",
    categoryId: "headphones",
    categorySlug: "headphones",
    description: "Adaptive noise-cancelling wireless headphones with Hi-Res Pure Bass sound, Spatial Sound technology, up to 76 hours of battery life and Bluetooth 6.0.",
    keyBenefits: ["Adaptive Active Noise Cancelling", "Hi-Res Spatial Sound", "Up to 76-hour battery"],
    usage: "Travel, work and commute with deep noise cancellation that adapts to your environment.",
    features: ["Adaptive ANC", "Spatial Sound", "Hi-Res", "Bluetooth 6.0"],
    inStock: true
  },

  // ----- Gaming Gear -----
  {
    id: "mka-7c-mechanical-keyboard",
    name: "MKA-7C White Mechanical Gaming Keyboard",
    slug: "mka-7c-mechanical-keyboard",
    sku: "EC-GMG-007",
    price: 33.00,
    image: "/products/p2-armaggeddon-mka-7c.png",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "Full-size 104-key clicky mechanical gaming keyboard with KevlarTech keycaps, RGB backlighting and 25-key anti-ghosting for precise inputs.",
    keyBenefits: ["Clicky mechanical switches", "Durable KevlarTech keycaps", "Per-key RGB backlight"],
    usage: "Plug-and-play via USB. Built for marathon gaming and typing sessions alike.",
    features: ["104 Keys", "Clicky Switches", "RGB", "Anti-Ghost"],
    inStock: true
  },
  {
    id: "deepfreeze-duplex-2-pc-case",
    name: "Deepfreeze Duplex 2 Chroma PC Case",
    slug: "deepfreeze-duplex-2-pc-case",
    sku: "EC-GMG-008",
    price: 39.00,
    image: "/products/p3-deepfreeze-duplex-2-black.png",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "Compact MATX / ITX gaming PC case with tempered glass front and side panels and a clean Chroma-ready airflow design.",
    keyBenefits: ["Dual tempered glass panels", "MATX & ITX support", "Optimized airflow layout"],
    usage: "Build a small-form gaming rig with a clear view of your RGB components from two sides.",
    features: ["MATX/ITX", "Tempered Glass", "Chroma-Ready", "Airflow Mesh"],
    inStock: true
  },
  {
    id: "aquaron-duplex-one-pc-case",
    name: "Aquaron Duplex ONE White PC Case",
    slug: "aquaron-duplex-one-pc-case",
    sku: "EC-GMG-009",
    price: 48.75,
    image: "/products/p6-aquaron-duplex-one.png",
    badge: "ARGB",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "Sleek white MATX / ITX gaming case with dual tempered glass panels and three pre-installed 12cm ARGB fans for vivid airflow lighting.",
    keyBenefits: ["3x 12cm ARGB fans included", "Dual tempered glass build", "MATX & ITX support"],
    usage: "Drop in your gaming components and sync the ARGB fans for a stunning lighting effect.",
    features: ["3x ARGB Fans", "Tempered Glass", "White Build", "MATX/ITX"],
    inStock: true
  },
  {
    id: "duo-stealth-wireless-combo",
    name: "Duo Stealth Wireless Keyboard & Mouse Combo",
    slug: "duo-stealth-wireless-combo",
    sku: "EC-GMG-010",
    price: 56.25,
    image: "/products/p8-armaggeddon-duo-stealth.png",
    badge: "Combo",
    categoryId: "gaming-gear",
    categorySlug: "gaming-gear",
    description: "Wireless gaming keyboard and mouse combo with an 85-key compact layout, 3200 CPI 6-button mouse and convenient USB-C charging.",
    keyBenefits: ["85-key compact layout", "3200 CPI 6-button mouse", "USB-C charging on both devices"],
    usage: "One dongle, two devices — perfect for a clean wireless gaming setup.",
    features: ["85 Keys", "3200 CPI", "Wireless", "USB-C"],
    inStock: true
  },

  // ----- Computer Accessories -----
  {
    id: "nomad-15-laptop-backpack",
    name: "Nomad-15 Carbon Laptop Backpack",
    slug: "nomad-15-laptop-backpack",
    sku: "EC-CMP-005",
    price: 58.00,
    image: "/products/p10-nomad-15-carbon.png",
    badge: "Travel",
    categoryId: "computer-accessories",
    categorySlug: "computer-accessories",
    description: "Travel-ready 15.6\" laptop backpack with splash-proof, scratch-resistant fabric, hidden USB-A and USB-C pass-through and dedicated multi-storage compartments.",
    keyBenefits: ["Fits up to 15.6\" laptops", "USB-A & USB-C pass-through ports", "Splash-proof, scratch-resistant"],
    usage: "Carry your laptop, tablet and tech essentials with a clean cable-free charging port on the strap.",
    features: ["15.6\" Fit", "USB Pass-Through", "Splash-Proof", "Multi-Storage"],
    inStock: true
  },

  // ----- Monitors & Displays -----
  {
    id: "pixxel-xf24hd-gaming-monitor",
    name: "Pixxel+ XF24HD 24\" 165Hz Gaming Monitor",
    slug: "pixxel-xf24hd-gaming-monitor",
    sku: "EC-DSP-005",
    price: 105.00,
    image: "/products/p15-pixxel-xf24hd.png",
    badge: "165Hz",
    categoryId: "displays",
    categorySlug: "displays",
    description: "24-inch Full HD IPS gaming monitor with a 165Hz refresh rate, 1ms response time and AMD FreeSync / NVIDIA G-Sync compatibility.",
    keyBenefits: ["165Hz refresh rate", "1ms response time", "FreeSync / G-Sync compatible"],
    usage: "Plug into PC or console for buttery-smooth competitive gaming and creator workflows.",
    features: ["24\" FHD", "165Hz", "1ms", "IPS Panel"],
    inStock: true
  },
  {
    id: "pixxel-pxp-27g-gaming-monitor",
    name: "Pixxel+ PXP 27G 27\" 165Hz Gaming Monitor",
    slug: "pixxel-pxp-27g-gaming-monitor",
    sku: "EC-DSP-006",
    price: 125.00,
    image: "/products/p17-pixxel-pxp-27g.png",
    badge: "27\" 165Hz",
    categoryId: "displays",
    categorySlug: "displays",
    description: "Spacious 27-inch Full HD IPS gaming monitor with 165Hz refresh, 1ms response, HDMI + DisplayPort and an immersive flat panel design.",
    keyBenefits: ["27-inch IPS panel", "165Hz / 1ms gaming-grade", "HDMI + DisplayPort inputs"],
    usage: "Upgrade your battlestation with a bigger view and pro-level gaming performance.",
    features: ["27\" FHD", "165Hz", "1ms", "HDMI + DP"],
    inStock: true
  },

  // ----- Smart Home & VR -----
  {
    id: "moto-watch-smartwatch",
    name: "Moto Watch Matte Black Smartwatch",
    slug: "moto-watch-smartwatch",
    sku: "EC-SMH-005",
    price: 101.00,
    image: "/products/p14-moto-watch-black.png",
    badge: "Smart",
    categoryId: "smart-home",
    categorySlug: "smart-home",
    description: "Stylish 1.43\" OLED smartwatch with dual-frequency GPS, full activity tracking, sleep & stress analysis and a long-lasting battery.",
    keyBenefits: ["Bright 1.43\" OLED display", "Dual-frequency GPS tracking", "Sleep & stress analysis"],
    usage: "Wear daily to track workouts, sleep and notifications from your phone right on your wrist.",
    features: ["1.43\" OLED", "Dual GPS", "Health Tracking", "Bluetooth"],
    inStock: true
  },
  {
    id: "hyperbox-1200-karaoke-speaker",
    name: "Hyperbox 1200 Pro Karaoke Speaker",
    slug: "hyperbox-1200-karaoke-speaker",
    sku: "EC-SMH-006",
    price: 110.00,
    image: "/products/p16-hyperbox-1200.png",
    badge: "Karaoke",
    categoryId: "smart-home",
    categorySlug: "smart-home",
    description: "Portable 110W karaoke speaker with a 12-inch driver, dedicated karaoke mode, USB / TF / AUX inputs, Bluetooth 5.4 and up to 250 minutes of playback.",
    keyBenefits: ["110W total output", "Dedicated karaoke mode", "Up to 250-minute playback"],
    usage: "Plug in a mic, stream tracks via Bluetooth and host instant karaoke nights anywhere.",
    features: ["110W", "12\" Driver", "Karaoke Mode", "Bluetooth 5.4"],
    inStock: true
  },
  {
    id: "hyperbox-1300-karaoke-speaker",
    name: "Hyperbox 1300 Pro Karaoke Speaker",
    slug: "hyperbox-1300-karaoke-speaker",
    sku: "EC-SMH-007",
    price: 150.00,
    image: "/products/p19-hyperbox-1300.png",
    badge: "240W",
    categoryId: "smart-home",
    categorySlug: "smart-home",
    description: "Stepped-up 240W karaoke speaker with a 12-inch driver, full karaoke functionality, USB / TF / AUX inputs and Bluetooth 5.4 streaming.",
    keyBenefits: ["240W room-filling power", "12-inch high-output driver", "USB / TF / AUX & Bluetooth"],
    usage: "Bring more punch to parties and outdoor gatherings — louder, bolder karaoke nights.",
    features: ["240W", "12\" Driver", "Karaoke", "Bluetooth 5.4"],
    inStock: true
  },
  {
    id: "hyperbox-1500-karaoke-speaker",
    name: "Hyperbox 1500 Pro Karaoke Speaker",
    slug: "hyperbox-1500-karaoke-speaker",
    sku: "EC-SMH-008",
    price: 170.00,
    image: "/products/p20-hyperbox-1500.png",
    badge: "15\" 240W",
    categoryId: "smart-home",
    categorySlug: "smart-home",
    description: "Top-tier 240W party karaoke speaker with a powerful 15-inch driver, full karaoke functionality, multi-source inputs and Bluetooth 5.4.",
    keyBenefits: ["15-inch high-power driver", "240W total output", "Multi-input party-ready"],
    usage: "Set up in living rooms, patios or event spaces for the biggest karaoke experience in the line.",
    features: ["240W", "15\" Driver", "Karaoke", "Bluetooth 5.4"],
    inStock: true
  },
];

// ============================================
// CATEGORIES
// ============================================
export const categories = [
  {
    id: "speakers",
    name: "Speakers",
    slug: "speakers",
    description: "Premium Bluetooth speakers, soundbars and audio systems for any space",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J09AS7CC0YW1C0Q7DZD6HAWH.jpg",
    productCount: 9
  },
  {
    id: "headphones",
    name: "Headphones & Earbuds",
    slug: "headphones",
    description: "Wireless, noise-cancelling and pro-grade headphones and earbuds",
    image: "https://novagen.s3.us-east-2.amazonaws.com/AcxyRrf2T4tOa7BmHEdstLp2TLtjgC0frVP7KRSZ.jpg",
    productCount: 15
  },
  {
    id: "gaming-gear",
    name: "Gaming Gear",
    slug: "gaming-gear",
    description: "Esports-tuned mice, mechanical keyboards and PC cases built for serious gamers",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01J0BP39GWWY6MQD879RXYW3W4.jpg",
    productCount: 10
  },
  {
    id: "computer-accessories",
    name: "Computer Accessories",
    slug: "computer-accessories",
    description: "Webcams, SSDs, power banks and laptop accessories for your setup",
    image: "https://novagen.s3.us-east-2.amazonaws.com/d2hRtvK6tNwuiU8ZOaYnwET7AUKI6K0tERt4cKpG.png",
    productCount: 5
  },
  {
    id: "tablets",
    name: "Tablets & Drawing",
    slug: "tablets",
    description: "Digital drawing tablets, e-readers and smart tablets for creators",
    image: "https://novagen.s3.us-east-2.amazonaws.com/zvQUJygDjugg5U1VK6sVHqpeE2Yo5Ou7EqV3eoiM.png",
    productCount: 6
  },
  {
    id: "displays",
    name: "Monitors & Displays",
    slug: "displays",
    description: "Gaming monitors, projectors and pro reference displays",
    image: "https://novagen.s3.us-east-2.amazonaws.com/YUyi0mcklSRlZjQRPLnURiaAbjsyoZvbZXsD6ceB.png",
    productCount: 6
  },
  {
    id: "smart-home",
    name: "Smart Home & VR",
    slug: "smart-home",
    description: "Smart home hubs, VR headsets, wearables and connected entertainment gear",
    image: "https://novagen.s3.us-east-2.amazonaws.com/eTAcRwGzxtvjNauVTAsJNe59HeK0FUzccLifq6n9.png",
    productCount: 8
  },
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Latest Tech', description: 'Curated selection of the newest electronics and smart gadgets' },
  { id: 2, title: 'Free USA Shipping', description: 'Free USPS shipping on every order' },
  { id: 3, title: '30-Day Returns', description: 'Easy returns within 30 days, no hassle' },
  { id: 4, title: 'Secure Checkout', description: 'Encrypted payments and protected customer data' }
];

export const performanceBenefits = [
  { id: 1, title: 'Performance', description: 'High-performance gadgets engineered for the modern lifestyle' },
  { id: 2, title: 'Innovation', description: 'Cutting-edge tech delivering tomorrow\'s features today' },
  { id: 3, title: 'Reliability', description: 'Built to last with quality components and tested durability' },
  { id: 4, title: 'Design', description: 'Sleek, user-friendly designs that fit seamlessly into your space' }
];

export const steps = [
  { id: 1, title: 'Browse', description: 'Explore our curated lineup of premium electronics and smart gadgets.' },
  { id: 2, title: 'Pick', description: 'Choose the gear, gadgets or accessories that fit your tech needs.' },
  { id: 3, title: 'Checkout', description: 'Complete your order with secure, encrypted payment.' },
  { id: 4, title: 'Enjoy', description: 'Unbox, plug in and power up your new tech.' }
];
